import React, { useState, useEffect, useRef } from "react";
import {Table, Empty, Form, Input, Button, Space, Modal, Select, message} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import * as InfoImage from '../../../../assets/images/info.png';
import FileConstants from "../../../../FileConstants";
import * as Utilities from "../../Utilities";
import ENVIRONMENT from '../../../../environments';
import axios from "axios";
import DottedLoader from "../../DottedLoader";
import SuccessModal from "../../SuccessModal/SuccessModal";
import { LoadingOutlined } from '@ant-design/icons';
import './CustomerReports.scss'
import NotificationControllerForm from "../../AdminComponents/NotificationController/NotificationControllerForm";

const MANAGED_CUSTOMER_USERNAME = FileConstants.MANAGED_CUSTOMER_USERNAME;
const IS_MS_PROVIDER = FileConstants.isMSProvider;
const MANAGED_COMPANY_ID = FileConstants.MANAGED_COMPANY_ID;

const { Option } = Select;

const UserDetails = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [filter_user_types, setFilterUserTypes] = useState([]);
    const [filter_subscription_types, setFilterSubscriptionTypes] = useState([]);
    const searchInputRefs = useRef({});
    const [show_subscription_modal, setShowSubscriptionModal] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState('');
    const [buttonLoader, setButtonLoader] = useState(false);
    const [success_modal, setSuccessModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [subscription_type, setSubscriptionType] = useState('');
    const [selectedCustomerNotificationSettings, setSelectedCustomerNotificationSettings] = useState({});
    const [notificationControllerModal, setNotificationControllerModal] = useState(false);
    const [updateNotificationSettingsLoader, setUpdateNotificationSettingsLoader] = useState(false);
    
    useEffect(() => {
        if(MANAGED_CUSTOMER_USERNAME) {
            handleDataSource();
        }
    }, []);

    const getColumns = () => [
      {
        title: 'Customer Username',
        dataIndex: 'customer_username',
        key: 'customer_username',
        ...getColumnSearchProps('customer_username','Username'),
        render: text => <span>{text}</span>,
      },
      {
        title: 'Customer Profile Name',
        dataIndex: 'profile_name',
        key: 'profile_name',
        ...getColumnSearchProps('profile_name','Profile Name'),
        render: text => <span>{text}</span>,
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        ...getColumnSearchProps('email','Email'),
        render: text => <span>{text}</span>,
      },
      {
        title: 'Company',
        dataIndex: 'company_name',
        key: 'company_name',
        ...getColumnSearchProps('company_name','Company Name'),
        render: text => <span>{text}</span>,
      },
      {
        title: 'Subscription Type',
        dataIndex: 'subscription_package',
        key: 'subscription_package',
        filters: filter_subscription_types,
        onFilter: (value, record) => record.subscription_package === value,
        render: (text, record) => 
          <span>
            {text} {text != 'Enterprise' && (<span>(<a onClick={() => openUserSubscriptionModal(record)}>Change</a>)</span>)}
          </span>,
      },
      {
        title: 'Actions',
        key: 'action_notification',
        dataIndex: 'action_notification',
        render: (text, record) => (
          <span>
            <a onClick={() => showNotificationControllerModal(record)}>View Notification Settings</a>
          </span>
        ),
      },
    ];

    const getColumnSearchProps = (dataIndex, placeholder) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              searchInputRefs.current[dataIndex] = node;
            }}
            placeholder={`Search ${placeholder}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
          : '',
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => searchInputRefs.current[dataIndex]?.select(), 100);
        }
      }
    });

    const showNotificationControllerModal = (record) => {
      console.log(record)
      setSelectedCustomer(record.customer_username);
      setSelectedCustomerNotificationSettings(record.notification_settings);
      setNotificationControllerModal(true);
    }
  
    const hideNotificationControllerModal = () => {
      setNotificationControllerModal(false);
    }
  
    const setNotificationSettings = (e, entity) => {
      console.log("Setting notification settings", e.target.checked, entity);
      setSelectedCustomerNotificationSettings(prevSettings => ({
        ...prevSettings,
        [entity]: e.target.checked
      }));
      
      // Also update the notification settings in the dataSource
      setDataSource(prevDataSource => 
        prevDataSource.map(item => 
          item.customer_username === selectedCustomer 
            ? {
                ...item,
                notification_settings: {
                  ...item.notification_settings,
                  [entity]: e.target.checked
                }
              }
            : item
        )
      );
    }
  
    const updateNotificationSettings = () => {
      setUpdateNotificationSettingsLoader(true);
  
      let payload = {
        'username': selectedCustomer,
        'notification_settings': selectedCustomerNotificationSettings
      }
  
      axios.post(ENVIRONMENT.UPDATE_CUSTOMERS_SETTINGS, payload)
        .then(res => {
          setUpdateNotificationSettingsLoader(false);
          hideNotificationControllerModal();
          message.info('Notification Settings Updated');
        })
    }

    const handleDataSource = () => {
      setIsLoading(true);
      let filter_user_values = [];
      let filter_subscription_values = [];
      axios.post(ENVIRONMENT.CUSTOMER_GET_BATCH, {'company_id': MANAGED_COMPANY_ID})
        .then(res => {
          console.log(res);
          console.log(res.data);
          var data = [];
          let user_type_value = null;
          let subscription_value = null;
          for (let i = 1; i <= (res.data).length; i++) {
            if (res.data[i - 1]['user_group'] === 'customer') {
              data.push({
                key: i,
                customer_username: res.data[i - 1]['customer_username'],
                profile_name: res.data[i - 1]['profile_name'],
                company_name: res.data[i - 1]['company_name'],
                user_type: res.data[i - 1]['user_type'],
                email: res.data[i - 1]['email'],
                payment_type: res.data[i - 1]['payment_type'],
                subscription_package: res.data[i - 1]['subscription_package'],
                notification_settings: res.data[i - 1]['notification_settings']
              });
              user_type_value = res.data[i - 1]['user_type'];
              subscription_value = res.data[i - 1]['subscription_package'];
              if (user_type_value && !filter_user_values.includes(user_type_value)) {
                filter_user_values.push(user_type_value);
              }
              if (subscription_value && !filter_subscription_values.includes(subscription_value)) {
                filter_subscription_values.push(subscription_value);
              }
            }
          }
          // sort alphabetically
          data = data.sort(function(a, b) {
            return a.customer_username.toLowerCase().localeCompare(b.customer_username.toLowerCase());
          });
          handleFilteringOptions(filter_user_values, filter_subscription_values);
          setDataSource(data);
          setIsLoading(false);
        })
    }

    const openUserSubscriptionModal = (record) => {
      console.log(record)
      setShowSubscriptionModal(true);
      setSelectedEmail(record.email);
      setSelectedCustomer(record.customer_username);
    }

    const handleFilteringOptions = (filter_user_type_values, filter_subscription_values) => {
      let filter_user_type_objects = [];
      filter_user_type_values.forEach(filter_user_type_value => {
        filter_user_type_objects.push({
          text: filter_user_type_value,
          value: filter_user_type_value,
        })
      });
  
      let filter_subscription_objects = [];
      filter_subscription_values.forEach(filter_subscription_value => {
        filter_subscription_objects.push({
          text: filter_subscription_value,
          value: filter_subscription_value,
        })
      });
  
      setFilterUserTypes(filter_user_type_objects);
      setFilterSubscriptionTypes(filter_subscription_objects);
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
    };
  
    const handleReset = clearFilters => {
      clearFilters();
    };

    const closeUserSubscriptionModal = () => {
        setSelectedEmail('');
        setSelectedCustomer('');
        setShowSubscriptionModal(false);
    }

    const selectSubscription = (e) => {
      setSubscriptionType(e);
    }

    const handleSubscriptionTypeChange = () => {
      setButtonLoader(true);
      let payload = {}
      payload.email = selectedEmail.toLowerCase();
      payload.subscription_type = subscription_type
      payload.username = selectedCustomer
      console.log('Payload', payload);
      axios.post(ENVIRONMENT.PERFORM_SUBSCRIPTION_ACTIVATION, payload)
      .then(res => {
          console.log(res);
          console.log(res.data);
          setShowSubscriptionModal(false);
          setSuccessModal(true);
          setButtonLoader(false);
      });
    }

    return (
        <>
            {isLoading ? (
              <DottedLoader />
            ) : MANAGED_CUSTOMER_USERNAME ? (
              <>
                <Table columns={getColumns()} dataSource={dataSource} />
              </>
            ) : 
            (
                <div style={{ position: "relative", top: "40%", height: "300px" }}>
                    <Empty className="default-user-empty" image={InfoImage} 
                    description={<span>Please select a customer from Top bar to view their models report</span>} />
                </div>
            )
            }
        <Modal
          title="Change User Subscription"
          visible={show_subscription_modal}
          onCancel={closeUserSubscriptionModal}
          footer={null}
          width={800}
          style={{ top: 200 }}
        >
          <Form className="input-form login-form" onFinish={handleSubscriptionTypeChange}>
          <div style={{ maxWidth: 500 }}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <div className="manrope f-24 black-55" style={{marginTop: 10, marginBottom: 10}}>Email: </div>
              <span className='f-16' style={{ fontSize: '18px', marginLeft: '5px' }}>{selectedEmail}</span>
            </div>
            <Form.Item rules={[{required: true, message: 'Please select a valid subscription package.'}]} name="payment_type">
                <Select showArrow disabled={buttonLoader} onSelect={e => selectSubscription(e)} className="manrope f-16 black-55 tree-select-material" placeholder="Subscription Package">
                    <Option value={"freemium"} className="manrope f-16 select-view">Freemium</Option>
                    <Option value={"enterprise"} className="manrope f-16 select-view">Enterprise</Option>
                </Select>
            </Form.Item>
          </div>
          <span className="justify-in-end mt-20">
              <Button disabled={buttonLoader} className="modal-okay-gray square font-14 mr-10" onClick={() => closeUserSubscriptionModal()}>
                  Cancel
              </Button>

              <Button htmlType="submit" disabled={buttonLoader} className="modal-okay square font-14">
                  Update&nbsp;{buttonLoader ? <LoadingOutlined /> : ''}
              </Button>
          </span>
          </Form>
        </Modal>

        <Modal
          visible={notificationControllerModal}
          onOk={hideNotificationControllerModal}
          onCancel={hideNotificationControllerModal}
          className="modal-share"
          footer={[
            <div className='justify-in-end'>
              <Button key="back" className="modal-okay square font-14"
              onClick={() => updateNotificationSettings()}
              >
               {updateNotificationSettingsLoader ? <span>Updating<LoadingOutlined spin style={{ marginLeft: 6 }} /></span> : <span>Update Settings</span>}
              </Button>
            </div>
          ]}
        >
          <NotificationControllerForm
          notification_settings={selectedCustomerNotificationSettings}
          setNotificationSettings={setNotificationSettings}
          />
        </Modal>

        <SuccessModal
          visible={success_modal}
          heading={"Account Subscription Updated!"}
          text={"Account subscription has been updated for the entered email."}
          footer={[
            <div className="justify-in-center">
                <Button style={{margin:"auto"}} className="modal-okay square font-14" htmlType="submit" onClick={() => {
                    window.location.reload();}}>
                    Okay
                </Button>
            </div>
          ]}/>
        </>
  )
}

export default UserDetails;
